// extracted by mini-css-extract-plugin
export var body = "_ok-8";
export var button = "_ok-0";
export var closeButton = "_ok-5";
export var content = "_ok-3";
export var empty = "_ok-f";
export var grid = "_ok-c";
export var header = "_ok-4";
export var icon = "_ok-1";
export var option = "_ok-d";
export var optionSelected = "_ok-e";
export var overlay = "_ok-2";
export var searchIcon = "_ok-a";
export var searchInput = "_ok-b";
export var searchWrapper = "_ok-9";
export var title = "_ok-6";
export var visuallyHidden = "_ok-7";